import {
    FETCH_STOKEZES_REQUEST,
    FETCH_STOKEZES_SUCCESS,
    FETCH_STOKEZES_FAILURE,
    CREATE_STOKEZ_SUCCESS,
    UPDATE_STOKEZ_SUCCESS,
    DELETE_STOKEZ_SUCCESS,
    TOGGLE_LOCK_STOKEZ_SUCCESS
  } from '../actions/stokezActions';
  import { PATCH_STOKEZ_BALANCE_AFTER_TRANSFER } from '../actions/transferBalancePatchActions';
  
  const initialState = {
    stokezes: [],
    loading: false,
    error: null
  };
  
  const stokezReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_STOKEZES_REQUEST:
        return { ...state, loading: true, error: null };
      case FETCH_STOKEZES_SUCCESS:
        return { ...state, loading: false, stokezes: action.payload, error: null };
      case FETCH_STOKEZES_FAILURE:
        return { ...state, loading: false, error: action.payload };
      case CREATE_STOKEZ_SUCCESS:
        if (!action.payload) return state;
        return { ...state, stokezes: [...state.stokezes, action.payload] };
      case UPDATE_STOKEZ_SUCCESS:
        return {
          ...state,
          stokezes: state.stokezes.map(stokez =>
            stokez._id === action.payload._id ? action.payload : stokez
          )
        };
      case DELETE_STOKEZ_SUCCESS:
        return {
          ...state,
          stokezes: state.stokezes.filter(stokez => stokez._id !== action.payload)
        };
        case TOGGLE_LOCK_STOKEZ_SUCCESS:
        return {
          ...state,
          stokezes: state.stokezes.map((stokez) =>
            stokez._id === action.payload?._id
              ? { ...stokez, isLocked: action.payload.isLocked, is_active: action.payload.is_active }
              : stokez
          )
        };
      case PATCH_STOKEZ_BALANCE_AFTER_TRANSFER: {
        const { username, balance } = action.payload;
        if (username == null || balance == null) return state;
        return {
          ...state,
          stokezes: state.stokezes.map((s) =>
            s.username === username ? { ...s, balance } : s
          ),
        };
      }
      default:
        return state;
    }
  };
  
  export default stokezReducer;